import { render, staticRenderFns } from "./ResultBoxCustom.vue?vue&type=template&id=c9d13d70&scoped=true&"
import script from "./ResultBoxCustom.vue?vue&type=script&lang=js&"
export * from "./ResultBoxCustom.vue?vue&type=script&lang=js&"
import style0 from "./ResultBoxCustom.vue?vue&type=style&index=0&id=c9d13d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d13d70",
  null
  
)

export default component.exports